import { HEADING_COLOR, type BlockComponentProps } from "./shared"

export function AccordionBlock({ content, resolved }: BlockComponentProps) {
  const ah = (content?.heading as string) ?? ""
  const aItems = (content?.items as Array<{ question: string; answer: string }>) ?? []
  const aCols = Math.min(2, Math.max(1, (content?.columns as number) ?? 1))
  if (aItems.length === 0) return null
  const accordionSectionClass = resolved.hasOverrides
    ? `px-4 @sm:px-6 @md:px-8 ${resolved.paddingClass || "py-8"} ${resolved.cornerClass} ${resolved.alignClass}`.trim()
    : "px-4 py-8 @sm:px-6 @md:px-8"
  return (
    <section className={accordionSectionClass} style={resolved.sectionStyle}>
      {ah && (
        <h2 className="text-2xl font-bold mb-6 text-center" style={{ color: HEADING_COLOR }}>
          {ah}
        </h2>
      )}
      <div className={aCols === 2 ? "grid gap-4 @md:grid-cols-2 max-w-4xl mx-auto" : "max-w-2xl mx-auto space-y-2"}>
        {aItems.map((item, i) => (
          <details key={i} className="group rounded-lg border bg-card">
            <summary className="list-none cursor-pointer px-4 py-3 font-medium flex items-center justify-between">
              <span>{item.question || "(No question)"}</span>
              <span className="group-open:rotate-180 transition-transform">▼</span>
            </summary>
            <div className="px-4 pb-3 pt-0 text-muted-foreground text-sm">
              {item.answer || ""}
            </div>
          </details>
        ))}
      </div>
    </section>
  )
}
